import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { API_CONSTANTS } from '../constants';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root',
})
export class WatchThemeService {
  constructor(private http: HttpClientService) {}

  getAll(query?: any) {
    return this.http.get(API_CONSTANTS.WATCH_THEMES, query).pipe(
      map((res: any) => res),
    );
  }

  getAvailable() {
    return this.http.get(`${API_CONSTANTS.WATCH_THEMES}/available`).pipe(
      map((res: any) => res),
    );
  }

  getById(id: string) {
    return this.http.get(`${API_CONSTANTS.WATCH_THEMES}/${id}`).pipe(
      map((res: any) => res),
    );
  }

  getBrief(id: string) {
    return this.http.get(`${API_CONSTANTS.WATCH_THEMES}/${id}/brief`).pipe(
      map((res: any) => res),
    );
  }

  create(payload: FormData) {
    return this.http.post(API_CONSTANTS.WATCH_THEMES, payload).pipe(
      map((res: any) => res),
    );
  }

  update(id: string, payload: FormData | Record<string, unknown>) {
    return this.http.put(`${API_CONSTANTS.WATCH_THEMES}/${id}`, payload).pipe(
      map((res: any) => res),
    );
  }

  retire(id: string) {
    return this.http
      .patch(`${API_CONSTANTS.WATCH_THEMES}/${id}`, { status: 'Retired' })
      .pipe(map((res: any) => res));
  }

  delete(id: string) {
    return this.http.remove(`${API_CONSTANTS.WATCH_THEMES}/${id}`).pipe(
      map((res: any) => res),
    );
  }
}
